export default __webpack_public_path__ + "static/media/connectionSpinner.0cf2fcfc.gif";